export const formatPhone = (value: string) => {
  const digits = value.replace(/\D/g, "").slice(0, 11);

  if (digits.length <= 3) return digits;

  if (digits.length <= 10) {
    const middle = digits.slice(3, 6);
    const last = digits.slice(6);

    return last
      ? `${digits.slice(0, 3)}-${middle}-${last}`
      : `${digits.slice(0, 3)}-${middle}`;
  }

  return `${digits.slice(0, 3)}-${digits.slice(3, 7)}-${digits.slice(7, 11)}`;
};